import { z } from 'zod';

export const InvoiceSettingsSchema = z.object({
  store_name: z.string().min(1, 'Store name is required'),
  store_address: z.string().min(1, 'Store address is required'),
  store_phone_number: z.string().min(1, 'Store phone number is required'),
  footer_thank_you_message: z.string().optional(),
  footer_terms_and_conditions: z.string().optional(),
});

export type InvoiceSettingsSchemaType = z.infer<typeof InvoiceSettingsSchema>;
